import styled from "@emotion/styled/macro";
import { useStorefrontDesignImages } from "hooks/useStorefrontDesignImages";

type CheckoutOfferImageProps = {
  designId?: string;
  designVersion?: number;
};

const CheckoutOfferImage = ({
  designId,
  designVersion,
}: CheckoutOfferImageProps) => {
  const designImages = useStorefrontDesignImages(designId, designVersion);
  const bgImageUrl = designImages.data?.smallImageUrl;

  return (
    <OfferDesignImage
      data-testid="checkout-offer-design-image"
      bgImageUrl={bgImageUrl!}
    />
  );
};
const OfferDesignImage = styled.div<{ bgImageUrl: string }>`
  width: 100%;
  aspect-ratio: 4/3;
  ${({ bgImageUrl }) =>
    bgImageUrl ? `background: url(${bgImageUrl}) no-repeat center;` : ""}
  background-size: cover;
  border-radius: 8px;
  margin-top: 20px;
`;

export { CheckoutOfferImage };
